import { render, staticRenderFns } from "./Comissao.vue?vue&type=template&id=cf69ebaa&scoped=true&"
import script from "./Comissao.vue?vue&type=script&lang=js&"
export * from "./Comissao.vue?vue&type=script&lang=js&"
import style0 from "./Comissao.vue?vue&type=style&index=0&id=cf69ebaa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf69ebaa",
  null
  
)

export default component.exports